module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDMiIHdpZHRoPSI4MDAiIGhlaWdodD0iNDAwIj48cGF0aCBmaWxsPSIjMDA4NzUxIiBkPSJNMCAwaDZ2M0gweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0yIDBoMnYzSDJ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/nga.svg
// module id = r5cy
// module chunks = 0